<template>
	<div class="cjt-container">
		<div class="cjt-head">
			<!-- 顶部导航栏 -->
			<top-nav-head></top-nav-head>
		</div>

		<div class="cjt-main">
			<!-- banner区域--start -->
			<div class="banner-container">
				<!-- banner区域--start -->
				<div class="swiper-container"></div>
				<!-- banner区域--end -->
			</div>
			<!-- banner区域--end -->

			<!--内容区域--start -->
			<div class="cjt-main-content-box">
				<!-- 广告上方快讯内容 -->
				<div class="cjt-main-content">
					<!-- tab切换区域--start -->
					<div class="cjt-policy-tabs">
						<div class="cjt-policy-tabs__header">
							<div class="cjt-policy-tabs__nav-wrap">
								<div
									v-for="(tab, index) in maintenanceTabs"
									:key="index"
									class="cjt-policy-tabs__item"
									:class="{ active: activeTabIndex === index }"
									@click="changeMaintenanceTab(index)"
								>
									<span class="cjt-policy-tabs__item-text">{{ tab.name }}</span>
								</div>
							</div>
						</div>
						<div class="cjt-policy-tabs__container">
							<!-- tab 切换内容区域 -->
							<transition name="fade-transform" mode="out-in">
								<div :key="activeTabIndex" class="cjt-policy-tabs__content">
									<!-- 行业快讯内容 -->
									<div v-if="activeTabIndex === 0">
										<div class="search-container">
											<div class="search-form">
												<div class="search-item">
													<span class="label">政策分类：</span>
													<el-select v-model="queryParams.policyType" placeholder="请选择政策分类" clearable>
														<el-option
															v-for="item in policyTypeDict"
															:key="item.dictCode"
															:label="item.dictValue"
															:value="item.dictCode"
														></el-option>
													</el-select>
												</div>
												<div class="search-item">
													<span class="label">政策名称：</span>
													<el-input v-model="queryParams.policyTitle" placeholder="请输入政策名称" clearable></el-input>
												</div>
												<div class="search-buttons">
													<el-button type="primary" @click="handleSearch">搜索</el-button>
													<el-button @click="resetSearch">重置</el-button>
												</div>
											</div>
										</div>

										<!-- 政策快讯列表 -->
										<div class="news-list">
											<template v-if="policyAllList.length">
												<div v-for="(item, index) in policyAllList" :key="index" class="news-item">
													<!-- 内容 -->
													<div class="news-content">
														<h3 @click="handleOpenSourceUrl(item.policySourceUrl)">{{ item.policyTitle }}</h3>
														<p :title="item.policyContent" @click="handleOpenSourceUrl(item.policySourceUrl)">
															{{ item.policyContent }}
														</p>
														<div class="meta">
															<div class="meta-info">
																<span>
																	<i class="el-icon-document"></i>
																	{{ policyTypeDict.find(i => i.dictCode === item.policyType)?.dictValue }}
																</span>
																<span>
																	<i class="el-icon-time"></i>
																	{{ item.createTime | formatDate }}
																</span>
															</div>
															<div v-if="token" class="actions">
																<span class="actions-btn collect" @click="handleCollectPolicy(item.id, item.isCollect)">
																	<svg-icon v-if="!item.isCollect" icon-class="collect" class="icon" />
																	<svg-icon v-else icon-class="collected" class="icon active" />
																	{{ item.isCollect ? '已收藏' : '收藏' }}
																</span>
																<span class="actions-btn subscriber" @click="handleSubscribePolicy(item.id, item.isSubscribe)">
																	<svg-icon v-if="!item.isSubscribe" icon-class="subscriber" class="icon" />
																	<svg-icon v-else icon-class="subscribered" class="icon active" />
																	{{ item.isSubscribe ? '已订阅' : '订阅' }}
																</span>
																<span class="actions-btn subscriber">
																	<svg-icon icon-class="Share" class="icon" />
																	分享
																</span>
															</div>
														</div>
													</div>
													<!--右侧图片-->
													<!-- <div class="news-image-container" v-if="item.showImage">
													<img src="@/assets/index/policy/policyImage.jpg" class="news-image" />
												</div> -->
												</div>
											</template>

											<!-- 数据为空 -->
											<empty-content v-else></empty-content>
										</div>

										<!-- 分页 -->
										<div v-if="pageOptions.total > pageOptions.limit" class="pagination-container">
											<jr-pagination
												:limit="pageOptions.limit"
												:page.sync="pageOptions.page"
												:total="pageOptions.total"
												layout="prev, pager, next"
												prev-text="上一页"
												next-text="下一页"
												@change="handlePaginationChange"
											></jr-pagination>
										</div>
									</div>

									<!-- 其他Tab内容 -->
									<div v-if="activeTabIndex === 1">
										<!-- 政策资讯我的收藏 -->
										<my-collect-policy></my-collect-policy>
									</div>

									<div v-if="activeTabIndex === 2">
										<!-- 政策资讯平台推送 -->
										<my-policy-push></my-policy-push>
									</div>
								</div>
							</transition>
						</div>
					</div>
				</div>
				<!-- 广告占位 -->
				<div class="poster-container">
					<img src="@/assets/index/policy/advertisement.jpg" alt="一键订阅 精准推送" style="width: auto;" />
				</div>
			</div>
			<!--内容区域--start -->
		</div>

		<!-- 微信扫码分享 -->
		<!-- <div class="wechat-share">
			<img src="@/assets/index/function/ewm_big.png" alt="" />
			<span>微信扫码分享</span>
		</div> -->
		<!-- 页脚 -->
		<page-footer></page-footer>
	</div>
</template>

<script>
	import TopNavHead from '@/components/TopNavHead'
	import PageFooter from '@/components/PageFooter'
	import JrPagination from '@/components/Pagination'
	import MyCollectPolicy from './components/myCollectPolicy.vue'
	import MyPolicyPush from './components/myPolicyPush.vue'
	import { getPolicyList } from '@/api/policy/index'
	import { saveUserCollect, subscribePolicy, unSubscribePolicy, removeUserCollect } from '@/api/userCenter/index'
	import { COLLECT_TYPE_STATE } from '@/enum/index'
	import { mapGetters } from 'vuex'
	import { mapDictionaries, preloadDictionaries } from '@/store/dictionary-helper'

	export default {
		name: 'Policy',
		components: {
			TopNavHead,
			PageFooter,
			JrPagination,
			MyCollectPolicy,
			MyPolicyPush
		},
		data() {
			return {
				// 当前tab栏索引
				activeTabIndex: 0,
				// tab切换栏目
				maintenanceTabs: [
					{ name: '行业快讯', id: '1' },
					{ name: '我的收藏', id: '2' },
					{ name: '平台推送', id: '3' }
				],
				// 所有政策快讯信息
				policyAllList: [],
				// 加载状态
				loading: false,
				// 分页配置
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				},
				// 查询参数
				queryParams: {
					policyType: '',
					policyTitle: ''
				}
			}
		},
		computed: {
			...mapGetters(['token']),
			// 使用自定义的映射函数
			...mapDictionaries('dictionary', ['policyTypeDict'])
		},
		created() {
			// 组件创建时预加载字典
			preloadDictionaries('dictionary', ['policyTypeDict'])
		},
		mounted() {
			this.handleQueryPolicyList()
		},
		methods: {
			// 查询所有政策快讯
			handleQueryPolicyList() {
				this.loading = true
				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					...this.queryParams
				}

				getPolicyList(params)
					.then(response => {
						const { data } = response
						if (data && data.records) {
							this.policyAllList = data.records || []
							this.pageOptions.total = data.total || 0
						} else {
							this.policyAllList = []
							this.pageOptions.total = 0
						}
						this.loading = false
					})
					.catch(() => {
						this.loading = false
						this.policyAllList = []
						this.pageOptions.total = 0
					})
			},

			// 查询所有政策快讯-分页
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.handleQueryPolicyList()
			},

			// 搜索
			handleSearch() {
				this.pageOptions.page = 1
				this.handleQueryPolicyList()
			},

			// 重置搜索
			resetSearch() {
				this.queryParams = {
					policyType: '',
					policyTitle: ''
				}
				this.pageOptions.page = 1
				this.handleQueryPolicyList()
			},

			// 新标签页打开政策快讯外链
			handleOpenSourceUrl(policySourceUrl) {
				window.open(policySourceUrl, '_blank')
			},

			// 用户收藏政策快讯
			handleCollectPolicy(id, flag) {
				const data = {
					collectIds: [id],
					collectType: COLLECT_TYPE_STATE.NEWS
				}
				if (flag) {
					removeUserCollect(data).then(response => {
						this.$modal.msgSuccess('取消收藏成功')
						this.handleQueryPolicyList()
					})
				} else {
					saveUserCollect(data).then(response => {
						this.$modal.msgSuccess('收藏成功')
						this.handleQueryPolicyList()
					})
				}
			},

			// 用户订阅政策快讯
			handleSubscribePolicy(id, flag) {
				const data = {
					policyFlashIds: [id]
				}
				if (flag) {
					unSubscribePolicy(data).then(response => {
						this.$modal.msgSuccess('取消订阅成功')
						this.handleQueryPolicyList()
					})
				} else {
					subscribePolicy(data).then(response => {
						this.$modal.msgSuccess('订阅成功')
						this.handleQueryPolicyList()
					})
				}
			},

			// 切换Tab
			changeMaintenanceTab(index) {
				this.activeTabIndex = index
				console.log(this.activeTabIndex, 'this.activeTabIndex')
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/policy/styles/policy.scss';
	.cjt-container {
		min-height: 100vh;
	}

	.banner-container {
		position: relative;
		z-index: 1;
		background-color: #f5f9fb;

		::v-deep {
			.swiper-container {
				width: 100%;
				height: 600px;
				background-image: url('~@/assets/index/policy/policy-banner01.jpg');
				// background-size: contain;
				background-position: center;
				background-repeat: no-repeat;
			}
		}
	}

	.cjt-main-content-box {
		background: #f5f9fb;
		padding-top: 20px;

		.cjt-main-content {
			background: #ffffff;
			width: 1400px;
			margin: 0 auto;
			padding: 20px;
			box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
		}
	}

	.wechat-share {
		position: absolute;
		right: 180px;
		top: 1120px;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		align-items: center;
		background-color: #ffffff;
		opacity: 0.8;
		box-shadow: 0px 1px 13px 0px rgba(62, 121, 147, 0.21);
		border-radius: 6px;
		height: 185px;
		width: 158px;
		img {
			width: 138px;
			height: 140px;
		}
		span {
			font-size: 14px;
			font-weight: normal;
			color: #333333;
		}
	}
	.actions-btn {
		.active {
			color: #2671cb;
		}
	}
</style>
